import Box from "@mui/material/Box";

import { useTranslate } from "@/common/hooks/useTranslate";
import { ConnectStripeButton } from "@/components/ConnectStripeButton/ConnectStripeButton";
import { DashboardInfobox } from "@/dashboard-design-system/Infobox";

export const StripeEmailAlert = ({ message }: { message?: string }) => {
  const { t } = useTranslate();

  return (
    <DashboardInfobox
      vibe="warning"
      size="small"
      type="alert"
      data-test="stripe-email-alert"
      customButton={
        <ConnectStripeButton variant="tonal" vibe="warning">
          {t("dashboard", "writeEmailModal.linkBankBanner.cta")}
        </ConnectStripeButton>
      }
    >
      <Box component="span" sx={{ fontWeight: 700, display: "block" }}>
        {t("dashboard", "writeEmailModal.linkBankBanner.title")}
      </Box>
      {message ?? t("dashboard", "writeEmailModal.linkBankBanner.body")}
    </DashboardInfobox>
  );
};
